var apidomain = {
  // 基础接口
  base: {
    prod: 'https://gfh.zkungfu.com/v128',
    //debug: 'http://172.16.168.155:7080',
    debug: 'http://gfh-backendapi-test-svc.gfh-test.svc.cluster.local:9000',
    test: 'http://zt.test.zkungfu.com/testbackendapi',
    huidu: 'https://gfhapi.zkungfu.com/v33'
  },
  // 基础接口 - 线路2
  line2: {
    prod: 'https://gfhapi.zkungfu.com/v113',
    //prod: 'https://gfhapi202304.zkungfu.com/v33',
    //debug: 'http://172.16.168.104:9000',
    //test: 'http://172.16.168.69:9000',
    //huidu: 'https://gfhapi.zkungfu.com/v33'
  },
  // 新菜谱
  newmenu: {
    prod: 'https://gfh.zkungfu.com/newmenu',
    //prod: 'https://gfhapi202304.zkungfu.com/newmenu',
    //debug: 'http://172.16.168.104:9038/newmenu',
    //test: 'http://172.16.168.58:9038/newmenu',
    //huidu: 'http://172.16.168.58:9038/newmenu'
  },
  // 钱包微服务
  wallet: {
    prod: 'https://gfh.zkungfu.com/walletservice/v98',
    //prod: 'https://gfhapi202304.zkungfu.com/walletservice/v98',
    //debug: 'http://172.16.168.104:9099',
    //test: 'http://172.16.168.68:9099',
    //huidu: 'https://gfh.zkungfu.com/walletservicetest/v30'
  },
  // 图片
  image: {
    prod: 'http://gfhapi.zkungfu.com/image2',
    //prod: 'http://gfhapi202304.zkungfu.com/image2',
    //debug: 'http://gfhapi.zkungfu.com/image3',
    //test: 'http://gfhapi.zkungfu.com/image3',
    //huidu: 'http://gfhapi.zkungfu.com/image3'
  },
  // 埋点
  report: {
    //prod: 'https://gfh.zkungfu.com/event
    //prod: 'https://gfhapi202304.zkungfu.com/event',
    prod: 'https://gfh.zkungfu.com/event',
    //debug: 'http://172.16.168.104:9035',
    //test: 'http://172.16.168.155/event',
    //huidu: 'http://172.16.168.155/event'
  },
  // 静态图片（不需区分测试/灰度/正式）
  staticImage: {
    prod: 'http://gfhapi.zkungfu.com/image2'
    //prod: 'http://gfhapi202304.zkungfu.com/image2'
  }
}

var api = {
  'reportPush': '/event-log/push', // 埋点上报
  'getCouponH5': '/activity-h5/receive', // h5活动手机领券接口
  'gotoCouponH5': '/activity-h5/send', // 用户真正获取到优惠券的接口，在进入优惠券列表的时候调用
  'queryCouponH5': '/activity-h5/query', // 获取活动配置
  'messageJump': '/activity-h5/message/jump', // URL Scheme打开小程序，通过h5做中转
  'generateUrlscheme': '/activity-h5/message/generateUrlscheme'
}

// 线路2访问
var api_line2 = {
  'lunched': '/order/Lunched' // 用户已出餐订单
}

function getUrl (path, suffix) {
  // 线路2接口
  if (api_line2.hasOwnProperty(path)) {
    return `${apidomain['line2'][suffix]}${api_line2[path]}`
  }
  return `${apidomain['base'][suffix]}${api[path]}`
}

function getUrl_Wallet_Service (path, suffix) {
  return `${apidomain['wallet'][suffix]}${api[path]}`
}

function getUrl_newmenu (path, suffix) {
  return `${apidomain['newmenu'][suffix]}${api[path]}`
}

function getUrl_image (suffix) {
  return `${apidomain['image'][suffix]}`
}

function getUrl_report (path, suffix) {
  return `${apidomain['report'][suffix]}${api[path]}`
}

function getUrl_Static_image () {
  return `${apidomain['staticImage']['prod']}`
}

module.exports.getUrl = getUrl
module.exports.getUrl_Wallet_Service = getUrl_Wallet_Service
module.exports.getUrl_newmenu = getUrl_newmenu
module.exports.getUrl_image = getUrl_image
module.exports.getUrl_report = getUrl_report
module.exports.getUrl_Static_image = getUrl_Static_image
